<div class="bmc-view-delta">
    <biz-topbar 
        (onClose)="closeViewDelta()" 
        [packageName]="_viewDeltaData.packageName" 
        [displayName]="'VIEW_DELTA.DISPLAY_NAME' | translate"
        [showSearch]="false">
    </biz-topbar>

    <ng-container *ngIf="isLoading">
        <div class="bz-loading-container">
            <bz-loading [size]="'l'"></bz-loading>
        </div>
    </ng-container>

    <div class="bmc-view-delta__main-section" *ngIf="!isLoading">
        <div [style.display]="showDetail ? 'none' : ''" aria-hidden="{{ showDetail }}">
            <biz-view-delta-filters
                [nameFilter]="filterName"
                [comparisonTypes]="availableDeltaTypes"
                [objectTypes]="availableObjTypes"
                [selectedDeltaType]="filterDeltaType"
                [selectedType]="filterObjType"
                [selectedViewMode]="viewMode"
                (filtersChange)="onFiltersChanged($event)">
            </biz-view-delta-filters>
        </div>
        
        <biz-view-delta-breadcrumb 
            [selectedCount]="selectedCount"
            [selectedItemName]="selectedItem ? (selectedItem.displayName || selectedItem.name) : ''"
            [isDownloading]="isDownloading"
            [hasDifferences]="selectedItemHasDifferences"
            (onTitleClick)="backToList()"
            (onDownloadSelected)="downloadSelected()"
            (onViewDifferences)="openDifferencesModal()">
        </biz-view-delta-breadcrumb>

        <div class="bmc-view-delta__list-container" [style.display]="showDetail ? 'none' : ''" aria-hidden="{{ showDetail }}">
            <biz-view-delta-list 
                [items]="deltaItems"
                [filterName]="filterName"
                [filterDeltaType]="filterDeltaType"
                [filterObjType]="filterObjType"
                (selectionChange)="selectedCount = $event"
                (selectedIdsChange)="onSelectedIdsChange($event)"
                (viewChangesClick)="openDetail($event)">
            </biz-view-delta-list>
        </div>

        <div class="bmc-view-delta__detail-container" [style.display]="showDetail ? '' : 'none'" aria-hidden="{{ !showDetail }}">
            <biz-view-delta-detail 
                [item]="selectedItem"
                (back)="backToList()">
            </biz-view-delta-detail>
        </div>
    </div>
</div>